import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { filter, Observable, tap } from 'rxjs';
import { PagesService } from 'src/app/pages/services/pages.service';
import { ProfileService } from 'src/app/pages/services/profile.service';
import { AuthService } from 'src/app/services';
import { LogoutTabComponent } from '../logout-tab/logout-tab.component';

@Component({
	selector: 'app-main-header',
	templateUrl: './main-header.component.html',
	styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit {
	profile$: Observable<any> = this.profileService.loadProfileData();

	routerURL$ = this.router.events.pipe(
		filter(val => val instanceof NavigationEnd),
		tap((val: any) => {
			if (val.url.indexOf('/app/jobfair') > -1) {
				this.class = 'jobfair';
			} else if (val.url.indexOf('/app/courses') > -1) {
				this.class = 'courses';
			} else if (val.url.indexOf('/app/company') > -1) {
				this.class = 'company';
			} else if (val.url.indexOf('/app/serverless') > -1) {
				this.class = 'serverless';
			} else if (val.url.indexOf('/app/profile') > -1) {
				this.class = 'profile';
			} else if (val.url.indexOf('/app/hubble') > -1) {
				this.class = 'hubble';
			} else if (val.url.indexOf('/app') > -1) {
			}
		}),
	);

	class = '';

	constructor(
		private router: Router,
		public modalController: ModalController,
		public popoverController: PopoverController,
		private profileService: ProfileService,
		public authService: AuthService,
		public pagesService: PagesService,
	) {
		//
	}

	ngOnInit() {
		//
	}

	logout() {
		this.authService
			.signOut()
			.then(data => {
				// comment
			})
			.catch(() => {
				// comment
			});
	}
	menuUpdate(str: any) {
		this.router.navigate([`app/${str}`]);
	}
	public async presentLogoutModal(event: any) {
		const modal = await this.popoverController.create({
			component: LogoutTabComponent,
			cssClass: 'logout-modal-class',
			event,
		});
		return await modal.present();
	}
	public dismiss() {
		this.modalController.dismiss({});
	}
}
